export class Mobile {
    static android() {
        return navigator.userAgent.match(/Android/i);
    }

    static blackBerry() {
        return navigator.userAgent.match(/BlackBerry/i);
    }

    static iOS() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    }

    static opera() {
        return navigator.userAgent.match(/Opera Mini/i);
    }

    static windows() {
        return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
    }

    static isPhone() {
        return (Mobile.android() || Mobile.blackBerry() || Mobile.iOS() || Mobile.opera() || Mobile.windows());
    }
}